import { createDotNetLinkUrl } from '../../../../../../../utils';

interface ListingUpgradeItem {
  badgeType?: string;
  heading: string;
  description: string;
  price: string;
  performance: string;
  contactUsLink: string;
}

export const useListingUpgradeItems = (): ListingUpgradeItem[] => [
  {
    heading: 'Standard',
    description:
      'Your listing ranks higher in search and is emailed to buyers daily.',
    price: '$749',
    performance: '2.4x',
    contactUsLink: createDotNetLinkUrl('/contact-us'),
  },
  {
    badgeType: 'Recommended',
    heading: 'Accelerate',
    description:
      'Your listing gets featured placement in search and buyer emails.',
    price: '$1,299',
    performance: '5.3x',
    contactUsLink: createDotNetLinkUrl('/contact-us'),
  },
];
